import {AgGridReact} from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import {useEffect, useState} from "react";
import "../public/styles/style.css";
import { Button, notification, Spin, message, Pagination } from "antd";
import { APIs } from "../constants/api.constants";
import {
  gridOption,
  frameworkComponents,
  dateFormatter,
  dateFilterParams,
  tagDropdownTextGetter,
} from "../constants/ag-grid.constants";
import {ApiService} from "../services/ApiService";
import AddAccessGroup from "../custom-components/access-group-popups/add-access-group";
import EditAccessGroup from "../custom-components/access-group-popups/edit-access-group";
import AddAccessGroupTag from "../custom-components/access-group-popups/add.tag";
import RemoveAccessGroupTag from "../custom-components/access-group-popups/remove-tag";
import DeleteAccessGroup from "../custom-components/access-group-popups/delete-access-group";
import Search from "antd/lib/input/Search";
import SortingTypeOption from "../custom-components/filter-and-sorting-popovers/sorting-type-option";
import { accessgroupSortingConstant } from "../constants/sorting.constants";

export default function Episodes() {
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [loading, setLoading] = useState(false);
  const [visible, setVisibility] = useState(false);
  const [data, setData] = useState([]);
  const [name, setName] = useState("");
  const [duration, setDuration] = useState("");
  const [fees, setFees] = useState(null);
  const [accessType, setAccessType] = useState("");
  const [newAccessType, setNewAccess] = useState("");
  const [courses, setCourses] = useState([]);
  const [loadingRows, setLoadingRows] = useState(false);
  const [isOpen, toggleEdit] = useState(false);
  const [editingData, setEditingData] = useState(null);
  const [sku, setSKU] = useState(null);
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [taggings, setTaggings] = useState([]);
  const [visibilityAddTag, setVisibilityAddTag] = useState(false);
  const [taggingName, setTaggingName] = useState("");
  const [visibilityRemoveTag, setVisibilityRemoveTag] = useState(false);
  const [taggingID, setTaggingID] = useState(null);
  const [selectRowID, setSelectedRowID] = useState([]);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [checkBox1, setCheckBox1] = useState(false);
  const [checkBox2, setCheckBox2] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [numOfSelect, setNumofSelect] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [totalAccessgroup, setTotalAccessgroup] = useState(null);
  const [filterValue, setFilterValue] = useState("");
  const [sort, setSort] = useState("idAscending")

  const columnDefs = [
    {
      headerName: "Access Group ID",
      field: "id",
      minWidth: 200,
      checkboxSelection: true,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      editable: false,
    },
    {
      headerName: "Access Group Name",
      field: "name",
      minWidth: 200,
      editable: false,
    },
    {
      headerName: "Duration(Days)",
      field: "duration",
      minWidth: 200,
      editable: false,
    },
    {
      headerName: "SKU",
      field: "sku",
      minWidth: 350,
      editable: false,
    },
    {
      headerName: "Tag(s)",
      field: "taggingName",
      editable: false,
      autoHight: true,
      cellStyle: {"white-space": "pre-wrap"},
      filter: 'agTextColumnFilter',
      valueGetter: tagDropdownTextGetter,
      cellRenderer: "taggingDropDownRenderer",
      cellRendererParams: {
        dropDownData: {
          items: taggings,
          type: "tagging_name",
          selectField: "tagging",
        },
        clicked: function (event) {
          setTaggingForAccessGroup(event);
        },
      },
      minWidth: 300,
    },
    {
      headerName: "Created Date",
      field: "createDate",
      valueGetter: dateFormatter,
      minWidth: 200,
      editable: false,
      filter: "agDateColumnFilter",
      filterParams: dateFilterParams,
    },
    {
      headerName: "Updated Date",
      field: "updateDate",
      valueGetter: dateFormatter,
      minWidth: 200,
      editable: false,
      filter: "agDateColumnFilter",
      filterParams: dateFilterParams,
    },
    {
      field: "Edit",
      editable: false,
      cellRenderer: "btnCellRenderer",
      cellRendererParams: {
        buttonText: "Edit",
        buttonClass: "primary",
        clicked: function (field) {
          setEditingData(field);
          setName(field.name);
          setSKU(field.sku);
          setDuration(field.duration);
          setSelectedCourses(field.course?.map((item) => item.id));
          toggleEditPopup();
        },
      },
      minWidth: 150,
    },
    {
      headerName: "Disable",
      field: "deletedAt",
      cellRenderer: "customSwitch",
      editable: false,
      sort: "asc",
      sortIndex: 0,
      cellRendererParams: {
        param: "deletedAt",
        clicked: function (field) {
          field.deletedAt
              ? recoverAccessGroup(field)
              : deleteAccessGroup(field);
        },
      },
      minWidth: 120,
    },
    {
      field: "Deleted",
      editable: false,
      cellRenderer: "btnCellRenderer",
      sortIndex: 0,
      cellRendererParams: {
        buttonText: "Delete",
        buttonClass: "primary",
        clicked: function (field) {
          setEditingData(field);
          setDeleteId(field.id)
          toggleDeletePopup()
        },
      },
      minWidth: 100,
    },
  ];

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  useEffect(() => {
    getAccessGroups();
    getCourses();
    getTaggings();
  }, []);

  function getAccessGroups(
    page = 1,
    limit = 100,
    sorting = "idAscending",
    filterValue
  ) {
    const param = {
      limit: limit,
      page: page,
      filterValue: filterValue,
      sorting: sorting,
    };
    setLoadingRows(true);
    ApiService.getRequest(APIs.accessGroup + "/pagination", param).then(
      (res) => {
        setTotalAccessgroup(res.data.meta.totalCount);
        setData(res.data.data);
        setLoadingRows(false);
      },
      (error) => notification["error"]({ message: error.message })
    );
  }

  function getCourses() {
    setLoadingRows(true);
    ApiService.getRequest(APIs.courses).then(
        (res) => {
          setCourses(res.data);
          setLoadingRows(false);
        },
        (error) => notification["error"]({message: error.message})
    );
  }

  function createAccessGroup() {
    setLoading(true);
    let postData = {
      name: name,
      duration: duration,
      regular_price: fees,
      access_type: accessType,
    };
    ApiService.postRequest(APIs.accessGroup, postData).then(
        (res) => {
          setData([...data, res.data]);
          setLoading(false);
          setVisibility(false);
          resetInputs();
        },
        (error) => {
          notification["error"]({message: error.message});
          setLoading(false);
          setVisibility(false);
        }
    );
  }

  function editAccessGroup(event) {
    const newData = {
      name: event.data.name,
      duration: event.data.duration,
      access_type: event.data.access_type,
      sku: event.data.sku,
    };
    ApiService.updateRequest(
        APIs.accessGroup + "/" + event.data.id,
        newData
    ).then(
      () => {
        getAccessGroups(page,limit,sort,filterValue);
        resetInputs();
      },
      (error) => notification["error"]({ message: error.message })
    );
  }

  function setCourseForAccessGroups(data) {
    const courseList = {
      id: data.id,
      course_list: data.items,
    };
    ApiService.postRequest(APIs.accessGroup + "/set-course", courseList).then(
      () => getAccessGroups(page,limit,sort,filterValue),
      (error) => notification["error"]({ message: error.message })
    );
  }

  function deleteAccessGroup(event) {
    ApiService.deleteRequest(APIs.accessGroup + "/" + event.id).then(
        () => getAccessGroups(),
        (error) => {
          notification["error"]({message: error.message});
        }
    );
  }

  function recoverAccessGroup(event) {
    ApiService.updateRequest(APIs.accessGroup + "/recover/" + event.id).then(
      () => getAccessGroups(page,limit,sort,filterValue),
      (error) => {
        notification["error"]({ message: error.message });
      }
    );
  }

  function getSelectedRowData(event) {
    let selectedNodes = event.api.getSelectedNodes();
    let selectedData = selectedNodes.map((node) => node.data.id);
    setSelectedRowID(selectedData);
    setNumofSelect(selectedData.length)
  }

  function setTaggingForAccessGroup(data) {
    const taggingList = {id: data.id, tagging_list: data.items};
    ApiService.postRequest(APIs.tagging + "/set-accessgroup", taggingList).then(
        () => {
        },
        (error) => notification["error"]({message: error.message})
    );
  }

  function createTag() {
    if (taggingName === "" && taggingID === null) {
      notification["error"]({message: "Please Select Values"});
      return;
    }
    // if tagging name were given
    else if (taggingName !== "") {
      setLoadingRows(true)
      const postData = {
        tagging_name: taggingName,
        tag_type: "ACCESSGROUP",
        accessgroupid_list: selectRowID,
      };
      ApiService.postRequest(APIs.tagging + "/create-and-set-accessgroup", postData).then(
        () => {
          message.success("Adding New Tag Successfully");
          setVisibilityAddTag(false);
          resetTagInput();
          getTaggings();
          getAccessGroups(page,limit,sort,filterValue);
          setLoadingRows(false);
        },
        (error) => {
          notification["error"]({ message: error.message });
          setLoadingRows(false);
          setVisibilityAddTag(false);
        }
      );
    }
    // if tagging name were not given and tagging ID is select
    else if (taggingName === "" && taggingID !== null) {
      setLoadingRows(true)
      const postData = {
        tag_id: taggingID,
        accessgroupid_list: selectRowID,
      };
      ApiService.postRequest(APIs.tagging + "/set-multi-accessgroup", postData).then(
        () => {
          message.success("Adding New Tag Successfully");
          setVisibilityAddTag(false);
          resetTagInput();
          getTaggings();
          getAccessGroups(page,limit,sort,filterValue);
          setLoadingRows(false);
        },
        (error) => {
          notification["error"]({ message: error.message });
          setLoadingRows(false);
          setVisibilityAddTag(false);
        }
      );
    }
  }

  function removeTag() {
    setLoadingRows(true);
    const deleteData = {
      id: taggingID,
      remove_from_list: selectRowID,
    };
    ApiService.postRequest(
      APIs.tagging + "/remove-tag-accessgroup",
      deleteData
    ).then(
      () => {
        message.success("Delete Tag Successfully");
        setVisibilityRemoveTag(false);
        resetTagInput();
        getTaggings();
        getAccessGroups(page, limit, sort, filterValue);
        setLoadingRows(false);
      },
      (error) => {
        notification["error"]({ message: error.message });
        setLoadingRows(false);
        setVisibilityRemoveTag(false);
      }
    );
  }

  function getTaggings() {
    ApiService.getRequest(APIs.tagging).then(
        (res) => setTaggings(res.data),
        (error) => notification["error"]({message: error.message})
    );
  }

  function resetTagInput() {
    setTaggingName("");
    setTaggingID(null);
    setSelectedRowID([]);
  }

  function toggleVisibilityAddTag() {
    visibilityAddTag && resetTagInput();
    setVisibilityAddTag(!visibilityAddTag);
  }

  function toggleVisibilityRemoveTag() {
    visibilityRemoveTag && resetTagInput();
    setVisibilityRemoveTag(!visibilityRemoveTag);
  }

  const showModal = () => {
    resetInputs();
    setVisibility(true);
  };

  function resetInputs() {
    setName("");
    setDuration("");
    setFees(null);
    setAccessType("");
    setNewAccess("");
    setSKU(null);
    setEditingData(null);
    setDuration(null);
    toggleEdit(false);
    setLoading(false);
    setSelectedCourses([]);
  }

  const handleCancel = () => {
    setVisibility(false);
  };

  function toggleEditPopup() {
    isOpen && resetInputs();
    toggleEdit(!isOpen);
  }

  function submitEdit() {
    const newData = {
      ...editingData,
      name: name,
      sku: sku,
      duration: duration,
    };
    if (selectedCourses.length) {
      const newCourses = {
        id: editingData.id,
        items: selectedCourses,
      };
      setCourseForAccessGroups(newCourses);
    }
    editAccessGroup({data: newData});
  }

  function resetDeleteInput() {
    setDeleteId(null);
    setEditingData(null);
    setCheckBox1(false);
    setCheckBox2(false);
  }

  function toggleDeletePopup() {
    deleteVisible && resetDeleteInput();
    setDeleteVisible(!deleteVisible);
  }

  function hardDelete() {
    if (checkBox1 !== true || checkBox2 !== true) {
      return notification["error"]({
        message: "please check all the checkbox to confirm deletion",
      });
    }
    setLoading(true);
    setLoadingRows(true);
    ApiService.deleteRequest(APIs.accessGroup + "/hard-delete/" + deleteId).then(
      () => {
        setLoading(false);
        toggleDeletePopup();
        getAccessGroups(page,limit,sort,filterValue);
        setLoadingRows(false);
      }
    ),
        (error) => {
          notification["error"]({message: error.message});
          setLoading(false);
          toggleDeletePopup();
          setLoadingRows(false);
        };
  }

  const accessGroupProps = {
    visible, createAccessGroup, handleCancel, loading, name, setName, duration, setDuration,
    fees, setFees, accessType, setAccessType, newAccessType, setNewAccess,
  };

  const editAccessGroupProps = {
    isOpen, toggleEditPopup, loading, submitEdit, courses, sku, setSKU, name, setName,
    duration, setDuration, selectedCourses, setSelectedCourses, editingData,
  };

  const addTagProps = {
    loading, toggleVisibilityAddTag, visibilityAddTag, taggingName, setTaggingName, createTag,
    taggings, setTaggingID, taggingID,
  };

  const removeTagProps = {
    loading, visibilityRemoveTag, toggleVisibilityRemoveTag, taggings, setTaggingID,
    taggingID, removeTag,
  };

  const deleteAccessGroupProps = {
    loading, deleteVisible, toggleDeletePopup, checkBox1, setCheckBox1, checkBox2,
    setCheckBox2, editingData, hardDelete
  }

  return <>
    <div className={"w-100percent row no-gutters"}>
      <div className={'col-md-6 pb-3'}>
        <strong>{numOfSelect} access groups have been select</strong>
      </div>
      <div className={'col-md-6 d-flex justify-content-end'}>
        <AddAccessGroupTag props={addTagProps}/>
        <RemoveAccessGroupTag props={removeTagProps}/>
        <Button type="primary" onClick={showModal}>
          Add New Row
        </Button>
        <AddAccessGroup props={accessGroupProps}/>
      </div>
    </div>

    <div className={"w-100percent row no-gutters"}>
      <div className="col-md-8 pb-3 pr-1">
        <Search placeholder="input search text"
                allowClear
                className={`w-100percent`}
                onSearch={(value) => {
                  setFilterValue(value);
                  getAccessGroups(page, limit, sort, value);
                }}
                prefix
                enterButton>
        </Search>
      </div>
      <div className="col-md-4 pb-3">
          <SortingTypeOption
            types={accessgroupSortingConstant}
            valueType={sort}
            changeFunction={(value) => {
              setSort(value);
              getAccessGroups(page, limit, value, filterValue);
            }}
          />
        </div>
    </div>


    <EditAccessGroup props={editAccessGroupProps}/>
    <DeleteAccessGroup props={deleteAccessGroupProps}/>

    <Spin tip="Loading...." size="small" spinning={loadingRows}>
      <div className="example-wrapper h-minus-230">
        <div className="ag-theme-alpine  w-100percent h-100percent">
          <AgGridReact
              rowData={data}
              columnDefs={columnDefs}
              defaultColDef={gridOption}
              animateRows={true}
              rowSelection={"multiple"}
              enableCellTextSelection={true}
              onCellValueChanged={editAccessGroup}
              frameworkComponents={frameworkComponents}
              getRowNodeId={function (data) {
                return data.id;
              }}
              onGridReady={onGridReady}
              onSelectionChanged={function (event) {
                return getSelectedRowData(event);
              }}
          ></AgGridReact>
        </div>
      </div>
      <div className="d-flex w-100percent justify-content-end pt-2">
        <Pagination
            onChange={(page, limit) => {
              setPage(page);
              setLimit(limit);
              getAccessGroups(page, limit, sort, filterValue);
            }}
            showQuickJumper
            defaultCurrent={1}
            total={totalAccessgroup}
            pageSize={limit}
            pageSizeOptions={[50, 100, 500, 1000]}
        />
      </div>
    </Spin>
  </>;
}
